import React from 'react'

import {
  Grid,
  Tooltip,
  Typography,
  makeStyles,
  Box,
  CircularProgress,
} from '@material-ui/core'

import styles from './styles'
import helpers from 'helpers'

const useStyles = makeStyles(styles)

const Header = ({ data, isLoading, ...rest }) => {
  const classes = useStyles()

  return (
    <>
      {isLoading ? (
        <Box
          display="flex"
          width="100%"
          minHeight="700px"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          className={classes.root}
          container
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={3}
        >
          <Grid xl={10} lg={9} md={8} sm={8} xs={12} item>
            <Tooltip title={helpers.functions.dig(data.department, 'name')}>
              <Typography variant="h4" className={classes.ellipsis}>
                {helpers.functions.dig(data.department, 'name')}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default Header
